<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <ReferralPromotionCreateAndUpdateFormItems :form="form" :data="referralPromotion" />
    </VForm>
</template>
<script>
import { rootActions, Getters } from '@/store/types'
import ReferralPromotionCreateAndUpdateFormItems from '@/components/ReferralPromotionCreateAndUpdateFormItems.vue'
import VForm from '@/components/VForm.vue'

export default {
    components: {
        ReferralPromotionCreateAndUpdateFormItems,
        VForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    computed: {
        referralPromotion () {
            return this.$store.getters[Getters.referral.GET_REFERRAL_PROMOTION](this.id)
        },
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.UPDATE_REFERRAL_PROMOTION, { id: this.id, ...values },
            )
            return res
        },
    },
}
</script>
